import { ActiveTiptapEditorSelector } from '../../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';
import { getMarksBetween } from '@tiptap/react';

export const selectIsMarkActive =
    (mark: string): ActiveTiptapEditorSelector =>
    (editor) =>
        editor?.isActive(mark);

// The logic is the same
export const selectIsNodeActive = selectIsMarkActive;

export const selectIsMarkWithinSelection =
    (mark: string): ActiveTiptapEditorSelector =>
    (editor) => {
        if (!editor) return false;

        const { from, to } = editor.state.selection;
        const doc = editor.state.doc;
        const markRanges = getMarksBetween(from, to, doc);

        return markRanges.some((range) => range.mark.type.name === mark);
    };

export const selectIsNodeWithinSelection =
    (nodeType: string): ActiveTiptapEditorSelector =>
    (editor) => {
        if (!editor) return false;

        const { from, to } = editor.state.selection;
        const doc = editor.state.doc;
        let found = false;

        doc.nodesBetween(from, to, (node) => {
            // Continue iteration
            if (node.type.name !== nodeType) return true;

            found = true;
            return false;
        });

        return found;
    };

export const selectIsSelectionRangeActive: ActiveTiptapEditorSelector = (editor) =>
    !!editor && !editor.state.selection.empty;
